import React, { Component } from 'react';
import cookie from '@/utils/cookie';
import qs from 'qs';
import { reportUserBehaviorCgi } from '@/api/operator/cgi/smb/common';

// 返回微广服务商系统
export class BackMpAgency extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: BackMpAgency.getMpBackShow(),
    };
  }

  static getMpBackShow() {
    const show = cookie.get('from_mp') == '1';
    if (show) {
      return show;
    }
    const param = qs.parse(window.location.search.substring(1));
    if (param.from_mp == '1') {
      cookie.set('from_mp', '1', null, '/', 24);
      return true;
    }
  }

  jumpToMp = () => {
    const reportData = {
      page1: '首页',
      behavior: '跳转微信服务商',
    };
    reportUserBehaviorCgi({ data: reportData });
    window.open('https://a.weixin.qq.com/client/');
  }

  render() {
    if (this.state.show) {
      return (
        <a
          onClick={this.jumpToMp}
          style={{ color: '#ffa600', marginRight: '10px', cursor: 'pointer' }}
          data-report-global="jump-to-mp-agency"
        >
          返回微广服务商系统
        </a>
      );
    }
    return null;
  }
}

// 页面初始化的时候，check一次，因为如果跳转登录，参数会丢失
BackMpAgency.getMpBackShow();
